module.exports = __webpack_public_path__ + "img/scan-outline.a4e437c8.svg";